import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;
const API = `${API_BASE_URL}/api/user` ;
function Wishlist() {

    const token = localStorage.getItem("token");

    const [wishlist, setWishlist] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        loadWishlist();

    }, []);

    const loadWishlist = async () => {

        try {

            const res = await axios.get(

                `${API}/wishlist`,

                {

                    headers: {

                        Authorization: `Bearer ${token}`

                    }

                }

            );

            setWishlist(res.data);

        }

        catch(err){

            console.log(err);

        }

        finally{

            setLoading(false);

        }

    };

    const removeWishlist = async(id)=>{

        try{

            await axios.delete(

                `${API}/wishlist/${id}`,

                {

                    headers:{

                        Authorization:`Bearer ${token}`

                    }

                }

            );

            loadWishlist();

        }

        catch(err){

            console.log(err);

        }

    };

    const addToCart = async(productId)=>{

        try{

            await axios.post(

                "http://localhost:5000/api/cart",

                {

                    productId,

                    quantity:1

                },

                {

                    headers:{

                        Authorization:`Bearer ${token}`

                    }

                }

            );

            alert("Product added to cart");

        }

        catch(err){

            console.log(err);

        }

    };

    if(loading){

        return(

            <div className="profile-card">

                Loading Wishlist...

            </div>

        );

    }

    return(

        <div className="profile-card">

            <div className="card-title">

                <h2>

                    My Wishlist

                </h2>

            </div>

            {

                wishlist.length===0 ?

                <div className="empty-box">

                    <h3>

                        Your Wishlist is Empty

                    </h3>

                    <p>

                        Save products that you love.

                    </p>

                </div>

                :

                <div className="wishlist-grid">

                {

                    wishlist.map((item)=>(

                        <div

                            className="wishlist-product"

                            key={item._id}

                        >

                            <Link

                                to={`/product/${item._id}`}

                            >

                                <img

                                    src={item.image}

                                    alt={item.name}

                                />

                            </Link>

                            <div className="wishlist-info">

                                <h3>

                                    {item.name}

                                </h3>

                                <p className="wishlist-category">

                                    {item.category}

                                </p>

                                <h2>

                                    ₹{item.price}

                                </h2>

                                <div className="wishlist-buttons">

                                    <button

                                        className="theme-btn"

                                        onClick={()=>

                                            addToCart(item._id)

                                        }

                                    >

                                        Add To Cart

                                    </button>

                                    <button

                                        className="outline-btn"

                                        onClick={()=>

                                            removeWishlist(item._id)

                                        }

                                    >

                                        Remove

                                    </button>

                                </div>

                            </div>

                        </div>

                    ))

                }

                </div>

            }

        </div>

    );

}

export default Wishlist;